module.exports = __webpack_public_path__ + "static/csr-0d9ed7079d6709ff3d8ad227f6d797a0.png";